// ======================================================================
// FILE: src/modules/finance/FinanceLayout.jsx
// MODULE: Finance & Accounts Management
// PURPOSE:
//   Common layout for the Finance module.
//
// FEATURES:
//   - Finance Sidebar
//   - Global Navbar
//   - Responsive content area
//   - Sidebar collapse support
//
// NOTES:
//   - Reuses global Navbar
//   - Sidebar controls content width
//   - No business logic
//   - No API calls
//
// AUTHOR: DizyPro ERP
// ======================================================================

import React, { useState } from "react";

import Navbar from "../../components/Navbar";
import FinanceSidebar from "./layout/FinanceSidebar";

// ======================================================================
// COMPONENT
// ======================================================================

export default function FinanceLayout({
  children,
}) {

  const [
    sidebarExpanded,
    setSidebarExpanded,
  ] = useState(true);

  return (

    <>

      <FinanceSidebar
        onToggle={setSidebarExpanded}
      />

      <div
        style={{
          marginLeft: sidebarExpanded ? 260 : 64,
          transition: "margin-left 0.22s ease",
          minHeight: "100vh",
          backgroundColor: "#f8fafc",
        }}
      >

        <Navbar />

        <div
          className="container-fluid"
          style={{
            padding: 24,
          }}
        >
          {children}
        </div>

      </div>

    </>

  );
}